// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { sync } from 'vuex-router-sync'
import NProgress from 'vue-nprogress'
import { messages } from './locale/'
import config from './config'
import axios from 'axios'
import moment from 'moment'
import VueAxios from 'vue-axios'

import VueAuth from '@websanova/vue-auth'
import VueAuthHttp from '@websanova/vue-auth/drivers/http/axios.1.x.js'
import VueAuthRouter from '@websanova/vue-auth/drivers/router/vue-router.2.x.js'

import VueI18n from 'vue-i18n'
import VueHead from 'vue-head'
import VeeValidate from 'vee-validate'
// eslint-disable-next-line no-duplicate-imports
import { Validator } from 'vee-validate'
import VueClipboard from 'vue-clipboard2'
import fa from 'vee-validate/dist/locale/fa'
import it from 'vee-validate/dist/locale/it'
import es from 'vee-validate/dist/locale/es'
import zh from 'vee-validate/dist/locale/zh_CN'
import ar from 'vee-validate/dist/locale/ar'
import pt from 'vee-validate/dist/locale/pt_BR'
import id from 'vee-validate/dist/locale/id'
import ms from 'vee-validate/dist/locale/ms_MY'

import Global from './plugins/global'
import Toasted from 'vue-toasted'
import VTooltip from 'v-tooltip'
import VueGtag from 'vue-gtag'

import { VueReCaptcha } from 'vue-recaptcha-v3'

Vue.use(
  VueGtag,
  {
    config: { id: 'GTM-KNVKFPQ5' },
  },
  router
)

Vue.use(VTooltip)
Vue.use(VueClipboard)
Vue.use(Global)
Vue.use(Toasted, {
  className: 'notification',
  duration: 4000,
  theme: 'primary',
})
/*, globalToasts : {
	myGlobalToast : function(payload, initiate){
		return initiate("My Deepest Condolence", 'error');
	},
}
*/

Vue.use(VueHead, {
  separator: '-',
  complement: 'EUROTRADER Client Area',
})
Vue.use(VeeValidate, {
  enableAutoClasses: true,
  classNames: {
    touched: 'touched',
    untouched: 'untouched',
    valid: 'is-success',
    invalid: 'invalid',
    pristine: 'pristine',
    dirty: 'dirty',
  },
})

Vue.router = router
Vue.use(VueAxios, axios)

Vue.use(VueAuth, {
  http: VueAuthHttp,
  router: VueAuthRouter,
  auth: {
    request: function (req, token) {
      this.http.setHeaders.call(this, req, {
        Authorization: token,
      })
    },
    response: function (res) {
      axios.defaults.headers['Authorization'] = res.data.token
      _service.defaults.headers['Authorization'] = res.data.token

      if (typeof res.data.userID !== 'undefined') {
        store.commit('user/SET_USER_INFO', {
          ID: res.data.userID,
        })
      }
      return res.data.token
    },
  },
  fetchData: {
    // enabled: false,
    url: config.API.host + 'authenticate/user',
  },
  stores: ['cookie', 'storage'],
  loginData: {
    url: config.API.host + 'authenticate/login?isClient=1',
    method: 'GET',
    fetchUser: false,
    // redirect: store.lang ? '/' + store.lang + '/login' : '/en/login'
  },
  logoutData: {
    redirect: store.lang ? '/' + store.lang + '/login' : '/en/login',
  },
  authRedirect: {
    path: store.lang ? '/' + store.lang + '/login' : '/en/login',
  },
  refreshData: {
    enabled: false,
  },
  getCookieDomain: function () {
    return process.env.NODE_ENV === 'development' ? 'localhost' : 'eurotrader.com'
  },
  cookie: {
    Path: '/',
    Domain: null,
    Secure: false,
    Expires: 12096e5, // This means two weeks
    SameSite: 'Lax',
  },
})

Vue.use(NProgress, {
  latencyThreshold: 1000,
  router: false,
  http: false,
})

Vue.use(VueI18n)

Vue.use(VueReCaptcha, { siteKey: config.recaptchaSiteKey })

// Enable devtools
Vue.config.devtools = true

Vue.config.productionTip = false

// const {
//   state
// } = store

const nprogress = new NProgress({
  parent: '.nprogress-container',
})

const i18n = new VueI18n({
  locale: store.getters['language/code'],
  fallbackLocale: 'en',
  messages,
})

axios.defaults.baseURL = config.API.host

const currencyFormat = {
  getMessage(field) {
    return i18n.t('only_currency_format_allowed')
  },
  validate(value) {
    if (value) {
      // return (/(?=.)^(([1-9][0-9]{0,2}(,[0-9]{3})*)|0)?(\.[0-9]{1,2})?$/.test(value))
      return /(?=.)^\$?(([1-9][0-9]{0,2}(,[0-9]{3})*)|[0-9]+)?(\.[0-9]{1,2})?$/.test(value)
    } else {
      return false
    }
  },
}

const minCurrencyValue = {
  getMessage(field, [min]) {
    return i18n.t('field_min_currency_value', {
      field: field,
      min: min,
    })
  },
  validate(value, [min]) {
    if (Array.isArray(value) || value === null || value === undefined || value === '') {
      return false
    }
    return Number(value.replace(',', '')) >= min
  },
}

const strongPassword = {
  getMessage(field) {
    return i18n.t('password_rules_extended')
  },
  validate(value) {
    if (value) {
      return /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*<>\+\=\{\}\(\)\?\:\;\,\.\\\/\|\'\"\`\_\-\~\[\]]).{8,16}$/.test(value)
    } else {
      return false
    }
  },
}

const multipleOf10 = {
  getMessage(field) {
    return i18n.t('must_be_multiple_of_10')
  },
  validate(value) {
    return value / 10 === Math.floor(value / 10)
  },
}

const emailAvailable = {
  getMessage(field) {
    return i18n.t('email_exists_message')
  },
  validate(value) {
    if (value) {
      return axios
        .post('/users/email-available', {
          email: value,
        })
        .then(response => {
          return {
            valid: response.data.available,
          }
        })
        .catch(e => {
          return false
        })
    } else {
      return false
    }
  },
}
const isIslamic = {
  getMessage(field) {
    return i18n.t('is_islamic_acc_message')
  },
  validate(value) {
    return value !== 'islamic'
  },
}
const isOver18 = {
  getMessage(field) {
    return i18n.t('must_be_over_18')
  },
  validate(year, args) {
    if (args.dob) {
      let now = moment()
      let dob = moment(args.dob, 'D-M-YYYY')

      return now.diff(dob, 'years') >= 18
    }

    return false
  },
}

const validCPF = {
  validate(cpf, args) {
    switch (args.country) {
      case 'BR':
        cpf = cpf.replace(/[^\d]+/g, '')
        if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) {
          return false
        }
        var sum = 0
        for (var i = 0; i < 9; i++) {
          sum += parseInt(cpf.charAt(i)) * (10 - i)
        }
        var rest = sum % 11
        var digit1 = rest < 2 ? 0 : 11 - rest
        sum = 0
        for (var i = 0; i < 10; i++) {
          sum += parseInt(cpf.charAt(i)) * (11 - i)
        }
        rest = sum % 11
        var digit2 = rest < 2 ? 0 : 11 - rest
        return digit1 === parseInt(cpf.charAt(9)) && digit2 === parseInt(cpf.charAt(10))
      default:
        return true
    }
  },
}

if (window.localStorage) {
  let url = location.pathname.split('/')
  if (url[1] !== '' && url[1].length === 2) {
    if (!url[1]) {
      url[1] = 'en'
    }
    window.localStorage.setItem('lang', url[1])
    store.commit('language/SET_LANGUAGE', url[1])
    i18n.locale = url[1]
  } else {
    let fallbackLang = 'en'
    store.commit('language/SET_LANGUAGE', fallbackLang)
    i18n.locale = fallbackLang
    if (url[1] !== 'deposit') {
      router.push('/' + fallbackLang)
    }
  }

  Validator.localize(store.getters['language/code'])
  // set app version
  window.localStorage.setItem('app-version', require('../static/auto-generated.json').version)
}

Validator.localize({
  fa,
  it,
  es,
  zh,
  ar,
  pt,
  id,
  ms,
})

Validator.extend('min-currency-value', minCurrencyValue)
Validator.extend('currency', currencyFormat)
Validator.extend('strong-password', strongPassword)
Validator.extend('multiple-of-10', multipleOf10)
Validator.extend('email-available', emailAvailable)
Validator.extend('is-islamic', isIslamic)
Validator.extend('is-over-18', isOver18, {
  hasTarget: true,
  paramNames: ['dob'],
})
Validator.extend('valid-cpf', validCPF, {
  paramNames: ['country'],
})

Vue.prototype.$locale = {
  change(language) {
    i18n.locale = language
    Validator.localize(i18n.locale)
    Validator.extend('min-currency-value', minCurrencyValue)
    Validator.extend('currency', currencyFormat)
    Validator.extend('strong-password', strongPassword)
    Validator.extend('multiple-of-10', multipleOf10)
    Validator.extend('email-available', emailAvailable)
    Validator.extend('is-islamic', isIslamic)
    Validator.extend('is-over-18', isOver18, {
      hasTarget: true,
      paramNames: ['dob'],
    })
  },
  current() {
    return i18n.locale
  },
}

router.beforeEach((to, from, next) => {
  let localLang = window.localStorage.getItem('lang')
  if (!localLang) {
    localLang = 'en'
  }
  const defaultURL = config ? config.defaultURL : ''

  // check route's required privileges
  if (to.matched.some(record => record.meta.needsPrivileges)) {
    if (app.$store.state.user.accountTypes.length) {
      let redirect = true
      for (let i = 0, l = to.matched[0].meta.needsPrivileges.length; i < l; i++) {
        if (app.$store.state.user.accountTypes.indexOf(to.matched[0].meta.needsPrivileges[i]) !== -1) {
          redirect = false
        }
      }
      // redirect to default
      if (redirect) {
        next({
          path: '/' + i18n.locale + '/' + defaultURL,
        })
        return
      }
    }
  }

  // set language if none
  if (to.path === '/') {
    store.commit('language/SET_LANGUAGE', localLang)
    i18n.locale = localLang
    const defaultURL = config ? config.defaultURL : ''
    next({
      path: '/' + localLang + '/' + defaultURL,
    })
    return
  }

  Validator.localize(localLang)
  next()
})

sync(store, router)

// event bus
const bus = new Vue()
Vue.prototype.$bus = bus

const app = new Vue({
  nprogress,
  router,
  store,
  i18n,
  ...App,
})

const _service = axios.create({
  baseURL: config.API.host,
  headers: {
    Authorization: app.$auth.token(),
  },
})

const service = {
  get(url, data, uid) {
    this._checkCreate(uid)
    let r = _service.get(url, data)
    r.then(response => {
      this._complete(uid)
    }).catch(() => {
      this._complete(uid)
    })
    return r
  },
  post(url, data, uid) {
    this._checkCreate(uid)
    let r = _service.post(url, data)
    r.then(response => {
      this._complete(uid)
    }).catch(() => {
      this._complete(uid)
    })
    return r
  },
  check(uid) {
    if (typeof store.getters['requests/all'][uid] !== 'undefined') {
      return store.getters['requests/all'][uid]
    }
    return false
  },
  _checkCreate(uid) {
    if (uid) {
      if (typeof store.getters['requests/all'][uid] === 'undefined') {
        let d = {
          completed: false,
        }
        store.dispatch('requests/add', {
          uid: uid,
          data: d,
        })
      } else if (store.getters['requests/all'][uid].completed) {
        let d = Object.create(store.getters['requests/all'][uid])
        d.completed = false
        store.dispatch('requests/edit', {
          uid: uid,
          data: d,
        })
      }
    }
  },
  _complete(uid) {
    if (uid) {
      let d = Object.create(store.getters['requests/all'][uid])
      d.completed = true
      store.dispatch('requests/edit', {
        uid: uid,
        data: d,
      })
    }
  },
}
_service.interceptors.request.use(
  function (config) {
    if (nprogress.status <= 0) {
      nprogress.inc(0.2)
    } else {
      nprogress.start()
    }
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)
_service.interceptors.response.use(
  function (response) {
    nprogress.done()
    return response
  },
  function (error) {
    if (error.response.data && parseInt(error.response.data.status) === 401) {
      if (app.$route.name !== 'Login') {
        // Delete popup cookie
        app.$deleteCookie('login_license_read')

        app.$auth
          .logout({
            makeRequest: false,
            params: {},
            // error: () => {
            // },
            redirect: '/en/login',
          })
          .then(() => {
            // Success
            store.commit('user/SET_USER_INFO', {})
            // app.$router.push('/en/login')
          })
      }
    }
    nprogress.done()
    return Promise.reject(error)
  }
)

// Get active currencies
Vue.prototype.$getCurrencies = function (active = true) {
  let result = {}
  for (let currency in config.currencies) {
    let c = config.currencies[currency]
    if (c.active || !active) {
      result[currency] = c
    }
  }

  return result
}

export { app, router, store, service }



// WEBPACK FOOTER //
// ./src/app.js